export const formatBZD = (number = 0) => {
  return new Intl.NumberFormat('en-BZ').format(number)
}
